module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get_768.c1d289e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/fullscreen-image_lets-get_768.png
// module id = n+gu
// module chunks = 0